export default __webpack_public_path__ + "img/t19.33cb9cbf.png";